(ns frontend.view.entity-viewers.modules.pre-exit-checks.view
  (:require
   [frontend.state.current-session :as session]
   [common.localization :as loc]
   [common.schema.entities.pipeline :as pipeline]
   [common.schema.registry :as registry]
   [frontend.state.permissions :as f-permissions]
   [frontend.zap-time :as zap-time]
   [frontend.view.modals.events :as modals]
   [frontend.view.modals.pre-exit-check.view :as pre-exit-check-modal]))

;;TODO generalize this and pre-investment-checks into more general functionality
;; when pre-action-check/pre-decision-check/action-point specs are more clear

(defn check-attribute-order
  []
  {:entity.type/exit-opportunity
   [:exit-opportunity/fund-manager-check
    :exit-opportunity/legal-and-compliance-check
    :exit-opportunity/asset-kyc-check
    :exit-opportunity/esg-sfdr-check
    :exit-opportunity/risk-check]
   :entity.type/oppo
   [:oppo/dd-budget-check
    :oppo/fund-manager-check
    :oppo/legal-and-compliance-check
    :oppo/asset-kyc-check
    :oppo/esg-sfdr-check
    :oppo/risk-check]})

(defn check-attributes
  "Check attributes readable on `entity`, permissioned against its own pipeline.
   Passing no pipeline here would fall back to the tenant-global field config
   and render checks the entity's pipeline has disabled - note the write check
   in `view` below has always been pipeline-scoped, so the two disagreed."
  [tenant-schema entity]
  (let [entity-type (:entity/type entity)
        pipeline-id (pipeline/entity-pipeline entity)
        check-entity-type (cond (= entity-type :entity.type/oppo)
                                :entity.type/pre-investment-check
                                (= entity-type :entity.type/exit-opportunity)
                                :entity.type/pre-exit-check)
        order (get (check-attribute-order) entity-type [])]
    (->> (registry/get-schema tenant-schema entity-type)
         (filter
          (fn [[_attribute field]]
            (-> field
                :field/entity-types
                set
                (contains? check-entity-type))))
         keys
         (filterv
          (fn [attribute]
            (let [can-read? (f-permissions/field-read-access? attribute
                                                              entity-type
                                                              pipeline-id)]
              can-read?)))
         (mapv
          (fn [attribute]
            {:attribute attribute
             :order     (.indexOf order attribute)}))
         (sort-by :order)
         (mapv :attribute))))

(defn view
  [{:keys [tenant-schema entities]
    {entity-type :entity/type :as entity} :entity}]
  [:div
   {:class "pt-3 flex flex-col"}
   (->>
    (check-attributes tenant-schema entity)
    (map
     (fn [attribute]
       (let [check-id (get entity attribute)
             {:keys [pre-exit-check/note pre-exit-check/conditions pre-exit-check/checked-on
                     pre-exit-check/status]
              :as   pre-exit-check}
             (get entities check-id)
             excerpt (if (empty? conditions) note conditions)
             ok-statuses #{:pre-exit-check.status/approved :pre-exit-check.status/conditionally-approved}]
         [:div
          {:class    "w-full py-2 px-3 flex justify-between items-center border-b border-solid border-base-light-border-paler"
           :key      (str "pre-exit-check-" attribute)
           :on-click (fn []
                       (modals/open-modal!
                        pre-exit-check-modal/modal-key
                        {:attribute   attribute
                         :entity-id   (:db/id entity)
                         :read-only?  (not (f-permissions/field-write-access?
                                            attribute entity-type
                                            (pipeline/entity-pipeline entity)))
                         :start-state pre-exit-check}))}
          [:div
           {:class "flex overflow-hidden cursor-pointer"}
           [:div
            {:class "flex items-center"}
            (if (contains? ok-statuses status)
              [:i.fas.fa-check-circle
               {:class "text-success-light-text"}]
              (if (= :pre-investment-check.status/not-approved status)
                [:i.fas.fa-times-circle {:class "text-danger-light-text"}]
                [:i.fal.fa-circle {:class "text-base-light-text"}]))
            (when checked-on
              [:div
               {:class "pl-3"}
               (zap-time/long->formatted-date checked-on)])]
           [:div
            {:class "pl-3 truncate"}
            (loc/field-name attribute (registry/get-field-schema tenant-schema attribute))]]
          (when-not (empty? excerpt)
            [:div
             {:class "truncate max-w-[80px] w-[80px]"}
             excerpt])]))))])

(defn header-view
  [tenant-schema entity]
  (let [attributes (check-attributes tenant-schema entity)
        total-count (count attributes)
        statuses (->> attributes
                      (map (partial get entity))
                      (map session/get-entity)
                      (map :pre-exit-check/status))
        done-count (->> statuses
                        (filter
                         #(or
                           (= % :pre-exit-check.status/approved)
                           (= % :pre-exit-check.status/conditionally-approved)))
                        count)]
    [:div
     {:style {:display     :flex
              :align-items :center
              :cursor      :default}}
     [:div
      {:style {:font-weight   "400"
               :color         "#a1a1aa"
               :padding-right "8px"}}
      (str done-count "/" total-count)]
     (cond
       (every? #{:pre-exit-check.status/approved} statuses)
       [:i.fas.fa-check-circle
        {:class "text-base-light-text-accent"}]
       (contains? (set statuses) :pre-exit-check.status/not-approved)
       [:i.fas.fa-times-circle
        {:class "text-danger-light-text"}]
       (every? #{:pre-exit-check.status/approved :pre-exit-check.status/conditionally-approved} statuses)
       [:i.fas.fa-check-circle
        {:class "text-warning-light-text"}]
       :else
       [:i.fal.fa-circle
        {:class "text-base-light-text-paler"}])]))
